/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 送信元コード (1:利用者, 2:ドライバー)
 * @export
 * @enum {number}
 */
export enum DestCodeEnum {
    /** 利用者 */
    USER = 1,
    /** ドライバー */
    DRIVER = 2
}

/**
 * 送信元コード (1:利用者, 2:ドライバー) の Union 型
 * @export
 * @typedef DestCode
 */
export type DestCode =
  typeof DestCodeEnum[keyof typeof DestCodeEnum];

/**
 * 送信元コード (1:利用者, 2:ドライバー) のラベルマップ
 * @export
 */
export const DestCodeLabels = {
    /**
     * 数値キー: DestCodeEnum.USER
     * 名前キー:  USER
     */
    [DestCodeEnum.USER]: '利用者',
    USER:                             '利用者',
    /**
     * 数値キー: DestCodeEnum.DRIVER
     * 名前キー:  DRIVER
     */
    [DestCodeEnum.DRIVER]: 'ドライバー',
    DRIVER:                             'ドライバー',
} as const;

/**
 * 送信元コード (1:利用者, 2:ドライバー) のラベル Union 型
 * @export
 * @typedef DestCodeLabel
 */
export type DestCodeLabel =
  typeof DestCodeLabels[keyof typeof DestCodeLabels];

/**
 * 送信元コード (1:利用者, 2:ドライバー) のラベル取得関数
 * @export
 * @param { DestCode } value - 列挙体の値
 * @returns { DestCodeLabel } ラベル文字列
 */
export function getDestCodeLabel(
  value: DestCode
): DestCodeLabel {
  return DestCodeLabels[value];
}

/**
 * 送信元コード (1:利用者, 2:ドライバー) のラベル配列を取得する関数
 * @export
 * @param { DestCode[] } values - 列挙体の値配列
 * @returns { DestCodeLabel[] } ラベル文字列配列
 */
export function getDestCodeLabels(values: DestCode[]): DestCodeLabel[] {
  return values.map((value) => getDestCodeLabel(value));
}

/**
 * 送信元コード (1:利用者, 2:ドライバー) のラベル配列
 * @export
 */
export const DestCodeLabelList = [
  '利用者','ドライバー',
] as const;

